// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"116":"glightbox","770":"keen-slider"}[chunkId] + ".js?v=" + {"116":"36037b2803eb65893e8a","770":"acb358ba44bde3df6f3c"}[chunkId] + "";
};